import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { AssessmentSessionDateResponse } from '../../../pages/Calendar/Calendar.types';

interface SessionListProps {
  sessions: AssessmentSessionDateResponse[];
  selectedSession: AssessmentSessionDateResponse;
  onChange: (event: SelectChangeEvent<string>) => void;
}

export const SessionList: React.FC<SessionListProps> = ({ sessions, selectedSession, onChange }) => {
  return (
    <>
      <FormControl
        style={{ width: '370px', position: 'relative', top: '55px', right: '55px', textAlign: 'left' }}
        size="small"
      >
        <InputLabel>Wybierz sesję oceniania</InputLabel>
        <Select
          variant="outlined"
          label="Wybierz sesję oceniania"
          value={selectedSession.examTaskGroupNameAndSheetCode}
          onChange={(event) => onChange(event)}
          inputProps={{
            color: '#000000',
            padding: '5px',
          }}
        >
          {sessions.map((session) => (
            <MenuItem disableRipple key={session.examTaskGroupNameAndSheetCode} value={session.examTaskGroupNameAndSheetCode}>
              Sesja oceniania:&nbsp;
              <span>
                <b>{session.examTaskGroupNameAndSheetCode}</b>
              </span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};
